<template>
  <li :id="'event-' + id"  class="event box">
    <div>{{ event.alias }}</div>
    <div>{{ event.name[lang] }}</div>
    <div><span v-if="event.score === 0">-</span><span v-else>{{ event.score }}</span></div>
    <div><span class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-indigo-100 rounded" :class="getClassByVisibility(event.visibility)">{{ event.visibility }}</span></div>
    <div><span v-if="event.frequencylimitation === 'none'">-</span><span v-else>{{ event.frequencylimitationvalue }} per {{ event.frequencylimitation }}</span></div>
    <div><span v-if="event.achievements.length === 0">-</span><span v-else>{{ event.achievements.length }}</span></div>
    <div>
      <dropdown class="actions" :actions="actions" @action="action"></dropdown>
      <event-form v-if="openEdition" :id="id" @close="closePopups"></event-form>
    </div>
  </li>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import dropdown from '@kevindesousa/vue-dropdown'
import eventForm from '@/components/events/event-form.vue'

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },

  components: { dropdown, eventForm },

  data () {
    return {
      actions: [{
        title: 'Edit',
        action: 'edit'
      },
      {
        title: 'Delete',
        action: 'delete'
      }],

      openEdition: false
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    ...mapGetters('events', {
      getById: 'getById'
    }),

    event () {
      return this.getById(this.id)
    }
  },
  methods: {
    ...mapActions('events', ['removeEvent']),

    getClassByVisibility (visibility) {
      switch (visibility) {
      case 'public':
        return { 'bg-green-700': true }
      case 'private':
        return { 'bg-blue-700': true }
      case 'hidden':
        return { 'bg-red-700': true }
      default:
        return { 'bg-grey-700': true }
      }
    },

    action (action) {
      switch (action) {
      case 'edit':
        this.openEdition = true
        break
      case 'delete':
        this.remove()
        break
      default:
        break
      }
    },

    remove () {
      this.removeEvent({ event: this.event })
        .then(() => {
          this.$notify({title: 'Success', message: this.$root.$t('notifications.event.deleted'), type: 'success'})
        })
        .catch((e) => {
          this.$notify.error({title: 'Error', message: this.$root.$t('notifications.unknown')})
        })
    },

    closePopups () {
      this.openEdition = false
    }
  }
}

</script>

<style lang="scss" scoped>
  .event.box {
    padding: 24px;
    margin-bottom: 12px;
    box-shadow: 0 0.1rem 1rem rgba(0, 0, 0, 0.08);
  }
</style>



// WEBPACK FOOTER //
// src/components/events/event.vue